<template>
  <el-main>
    <div id="login">
      <el-form :model="magicNumber" :rules="rules" ref="ruleForm">
        <el-row>投票コードを貼り付けてください。</el-row>
        <el-row>
          <el-input
            v-model="magicNumber.magicNumber"
            placeholder="コードを貼り付けもしくは入力"
          ></el-input>
        </el-row>
        <el-row>
          <el-alert
            :title="message"
            :type="successful ? 'success' : 'error'"
            v-if="message != ''"
          ></el-alert>
        </el-row>

        <el-row style="padding: 2px;">
          <el-button
            type="primary"
            style="width: 100%;"
            v-if="isClipboardEnable"
            @click="onCodePasteClick"
            >コード貼り付け</el-button
          >
        </el-row>
        <el-row style="padding: 2px;">
          <el-button type="primary" style="width: 100%;" @click="onLoginClick"
            >次へ</el-button
          >
        </el-row>
        <el-row style="margin: 1em; font-size: 0.75em;">
          <div style="margin-top: 1em;">コード貼り付けができない場合</div>
          <div style="margin-top: 1.5em;">
            <div>・スマートフォンご利用の方</div>
            <div style="margin-top: 0.5em; padding-left: 1em;">
              入力枠内を長押しし「ペースト」または「貼り付け」というメニューが表示されたらタップしてください。
            </div>
          </div>
          <div>
            <div style="margin-top: 1.5em;">
              ・パソコンをご利用の方
            </div>
            <div style="margin-top: 0.5em; padding-left: 1em;">
              入力枠内で右クリックし表示されるメニューから「貼り付け」を選択してください。
              メニューが表示されない場合は、入力枠内をクリックした後、「Ctrl」キーを押しながら「V」キーを押してください。
            </div>
          </div>
        </el-row>
      </el-form>
    </div>
  </el-main>
</template>

<script>
import store from "../store";

import firebase from "firebase";
import userService from "../services/user.service";
import axios from "axios";

export default {
  name: "LoginMagicNumber",
  data() {
    return {
      successful: false,
      isClipboardEnable: false,
      magicNumber: {
        magicNumber: "",
      },
      loading: false,
      message: "",
      rules: {
        magicNumber: [
          {
            required: true,
            message: "投票コードを入力してください。",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    loggedIn() {
      return store.state.auth.status.loggedIn;
    },
  },
  created() {
    if (this.loggedIn) {
      this.$router.push({ name: "redirect-to-etohyo" });
    }
  },
  async mounted() {
    // await this.$nextTick();
    if (navigator.clipboard) {
      this.isClipboardEnable = true;
    } else {
      this.isClipboardEnable = false;
    }
  },
  methods: {
    onCodePasteClick() {
      navigator.clipboard.readText().then(text => {
        this.magicNumber.magicNumber = text;
      });
    },
    async onLoginClick() {
      this.loading = true;
      try {
        const result = await this.$store.dispatch(
          "auth/signinMagicNumber",
          this.magicNumber.magicNumber,
        );
        console.log(result);
        let messaging = null;
        if (firebase.messaging.isSupported()) {
          console.log("+++B");
          messaging = firebase.messaging();
          messaging
            .getToken({
              vapidKey: `${process.env.VUE_APP_FIREBASE_VAPID_KEY}`,
            })
            .then(currentToken => {
              console.log("+++C");
              if (currentToken) {
                console.log(`login currentToken=${currentToken}`);
                userService.setToken(currentToken);
                console.log("++OK");

                this.$router.push({ name: "redirect-to-etohyo" });
              } else {
                // Show permission request.
                console.log(
                  "No registration token available. Request permission to generate one.",
                );
                // Show permission UI.
                // updateUIForPushPermissionRequired();
                // setTokenSentToServer(false);
                this.$router.push({ name: "redirect-to-etohyo" });
              }
            })
            .catch(err => {
              console.log("An error occurred while retrieving token. ", err);

              this.$router.push({ name: "redirect-to-etohyo" });
              // showToken("Error retrieving registration token. ", err);
              // setTokenSentToServer(false);
            });
        } else {
          this.$router.push({ name: "redirect-to-etohyo" });
        }
      } catch (error) {
        console.log(error);
        console.log("singin erro!");
        this.successful = false;
        this.loading = false;
        console.log(error);
        this.message = "ログインできませんでした。";
      }
    },
    ssoLoginToETohyo(user) {
      let formData = new FormData();
      formData.append("UserID", this.md5hex(user.loginID));
      axios
        .post("https://zm.etohyo.com/cmn_sso_online.aspx", formData)
        .then(response => {
          return response.data;
        });
    },
  },
};
</script>

<style></style>
